import { render, staticRenderFns } from "./PointComponent.vue?vue&type=template&id=ea5a3076&"
import script from "./PointComponent.vue?vue&type=script&lang=ts&"
export * from "./PointComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports